// extracted by mini-css-extract-plugin
export default {"container":"NotificationsList_container__YTgeC"};